import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext'; // Import useAuth
import './App.css';

import AssessorPage from './pages/AssessorPage';
import CandidateTestPage from './pages/CandidateTestPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import AssessmentResultPage from './pages/AssessmentResultPage'; 
import BillingPage from './pages/BillingPage'; 
import LandingPage from './pages/LandingPage'; // <-- NEW IMPORT
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import HowItWorksPage from './pages/HowItWorksPage';
import ProfilePage from './pages/ProfilePage';
import VerifyEmailPage from './pages/VerifyEmailPage'; // <--- Import
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SuccessPage from './pages/SuccessPage'; // <--- Import
import ContactPage from './pages/ContactPage';

// Helper component to redirect logged-in users away from Landing Page
function PublicOnlyRoute({ children }) {
  const { token } = useAuth();
  if (token) {
    return <Navigate to="/app" replace />; // Redirect to app if logged in
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        
        {/* --- Public Routes --- */}
        {/* Homepage is now the Landing Page (only if not logged in) */}
        <Route path="/" element={
          <PublicOnlyRoute>
             <LandingPage />
          </PublicOnlyRoute>
        } />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        {/* --- Public Legal Pages --- */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />

        <Route path="/login" element={<LoginPage />} />
        {/* We need a Signup page route eventually, for now use Login */}
        <Route path="/signup" element={<SignupPage />} /> 
        
        <Route path="/take/:linkToken" element={<CandidateTestPage />} />
        <Route path="/verify" element={<VerifyEmailPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* --- Protected Routes --- */}
        <Route element={<ProtectedRoute />}>
          {/* We move the Assessor Tool to "/app" */}
          <Route path="/app" element={<AssessorPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          {/* Changed :assessmentId to :linkToken */}
          <Route path="/assessment/:linkToken" element={<AssessmentResultPage />} />
          <Route path="/billing" element={<BillingPage />} /> 
          <Route path="/success/:linkToken" element={<SuccessPage />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;